/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { ResourceInterface } from '@app/shared/models/resource.interface';
import { ApiQuery } from '@app/core/http/api-query';
import { Observable } from 'rxjs';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { User } from '@app/settings/users/user.model';
import { map } from 'rxjs/operators';
import { HttpResponse } from '@app/core';
import { HttpClient } from '@angular/common/http';
import * as FileSaver from 'file-saver';

@Injectable({
  providedIn: 'root',
})
export class UsersService implements ResourceInterface {
  constructor(private http: HttpClient) {}

  destroy(id: number): Observable<any> {
    return this.http.delete('v1/users/' + id);
  }

  index(query: ApiQuery): Observable<PaginatedResponse> {
    return this.http.get('v1/users', query.buildGetOptions()).pipe(
      map((response: HttpResponse) => {
        response.data = response.data.map((user: any) => {
          return new User().deserialize(user);
        });

        return new PaginatedResponse().deserialize(response);
      })
    );
  }

  show(id: number, query: ApiQuery = new ApiQuery()): Observable<User> {
    return this.http.get('v1/users/' + id, query.buildGetOptions()).pipe(
      map((response: HttpResponse) => {
        return new User().deserialize(response.data);
      })
    );
  }

  store(model: User): Observable<User> {
    return this.http.post('v1/users', model).pipe(
      map((response: HttpResponse) => {
        return new User().deserialize(response.data);
      })
    );
  }

  update(model: User): Observable<User> {
    return this.http.put('v1/users/' + model.id, model).pipe(
      map((response: HttpResponse) => {
        return new User().deserialize(response.data);
      })
    );
  }

  export(query: ApiQuery = new ApiQuery()) {
    return this.http.download('v1/users', query.buildGetOptions()).subscribe((data: any) => {
      const blob = new Blob([data], {
        type: 'application/vnd.ms-excel;charset=utf-8',
      });
      FileSaver.saveAs(blob, 'users.xlsx');
    });
  }
}
